import React from 'react';
import image from '../../../Assets/Backgrounds/prototypeBg.webp';
import SharedBanner from '../../Shared/SharedBanner/SharedBanner';
const Banner=()=>{
    return(
        <>
        <SharedBanner 
        title="Prototyping"
        backgroundImage={image}
        styles="noshade"
        />
        </>
    )
}
export default Banner ;

